export const primary_color = "#1D1752"
export const secondary_color = "#ffffff"
export const green_color = "#8CC640";